import { IButtonGroupItemProps, ICardProps, Popover } from '@enter/core';
import { mdiChevronRight, mdiDotsVertical } from '@mdi/js';
import _ from 'lodash';
import { Granularity } from '../../models';
import React from 'react';
import * as S from './chart-card.styles';

export interface IChartCardProps extends ICardProps {
    title?: string;
    info?: React.ReactElement;
    selectedGranularity?: Granularity;
    onGranularitySelect?: (g: Granularity) => void;
    Caption?: React.ReactElement;
    Options?: React.ReactElement;
    Legend?: React.ReactElement;
    Link?: React.ReactElement;
}

export class ChartCard extends React.PureComponent<IChartCardProps> {
    public render(): React.ReactElement {
        return (
            <S.ChartCard size={this.props.size} className={this.props.className}>
                <S.Header>
                    {this.renderTitle()}
                    {this.renderGranularities()}
                    {this.renderCaption()}
                    {this.renderOptions()}
                </S.Header>
                <S.Contents size={this.props.size}>
                    {this.props.children}
                    {this.renderLegend()}
                </S.Contents>
                {this.renderFooter()}
            </S.ChartCard>
        );
    }
    private readonly renderTooltip = (): React.ReactElement => {
        return <div>{this.props.info}</div>;
    };
    private readonly renderTitle = (): React.ReactElement => {
        return (
            <S.Title>
                {this.props.title}
                {this.props.info && (
                    <S.StyledInfoIcon variant="equation" direction="bottom" tooltip={this.renderTooltip()} />
                )}
            </S.Title>
        );
    };
    private readonly renderGranularities = (): React.ReactElement | undefined => {
        const { selectedGranularity, onGranularitySelect } = this.props;
        if (selectedGranularity && onGranularitySelect) {
            const buttons = Object.values(Granularity)
                .filter(_.isString)
                .map((label: string) => ({ label }));
            const selected = _.find(buttons, {
                label: selectedGranularity,
            });
            const onSelect = (button: IButtonGroupItemProps): void => {
                const g = button.label as keyof typeof Granularity;
                onGranularitySelect(Granularity[g]);
            };
            return <S.Granularities buttons={buttons} selected={selected} onSelect={onSelect} />;
        }
    };
    private readonly renderCaption = (): React.ReactElement | undefined => {
        if (this.props.Caption) {
            return (
                <S.Caption>
                    <S.Captioned>{this.props.Caption}</S.Captioned>
                </S.Caption>
            );
        }
    };
    private readonly renderOptions = (): React.ReactElement | undefined => {
        if (this.props.Options) {
            return (
                <Popover align="right" renderButton={this.renderOptionsButton} selectable={true}>
                    {this.props.Options}
                </Popover>
            );
        }
    };
    private readonly renderOptionsButton = (): React.ReactElement => {
        return (
            <S.OptionsLink>
                <S.OptionsIcon path={mdiDotsVertical} />
            </S.OptionsLink>
        );
    };
    private readonly renderLegend = (): React.ReactElement | undefined => {
        if (this.props.Legend) {
            return this.props.Legend;
        }
    };
    private readonly renderFooter = (): React.ReactElement | undefined => {
        // NB: remove until link destinations are supported (invoice/reports)
        if (false && this.props.Link) {
            return (
                <S.Footer>
                    <S.FooterLink>
                        {this.props.Link}
                        <S.FooterLinkIcon path={mdiChevronRight} />
                    </S.FooterLink>
                </S.Footer>
            );
        }
        return undefined;
    };
}
